<template>
    <a-modal
        title="工资账单"
        :visible="visible"
        class="modal-initialize"
        width="508px"
        @cancel="cancelFun"
        @ok="okFun"
    >
        <div class="bomb-remind">
            <div class="bomb-form">
                <a-form class="inline-form" :form="form">
                    <a-form-item label="工资账单月" v-bind="formItemLayout">
                        <a-month-picker
                            style="width: 100%"
                            placeholder="请选择工资账单月"
                            v-decorator="['month',{rules: [{ required: false, message: '请选择工资账单月' }]} ]"
                        />
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </a-modal>
</template>

<script>
import moment from "moment";

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        eid: {
            type: String,
            default: ''
        },
        sbid: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            formItemLayout: {
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 18
                },
            },
            dateFormat: 'YYYY-MM',
        };
    },
    watch: {
        // 实现双向绑定
        visible(val) {
            if (val === false) {
                this.form.resetFields(); // 重置表单
            } else {
                this.getData();
            }
        },
    },
    model: {
        prop: 'visible',
        // 这个事件名可以随意写，它实际上是规定了子组件要更新父组件值需要注册的方法
        event: 'changeVisible'
    },
    methods: {
        closeModal() {
            this.$emit('changeVisible', false);
        },
        getData() {
            let data = {};
            data.sbid = this.sbid;

            this.http('/manage/sabill/info', data, (res) => {

                if (this.sbid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            month: res.data.month != '0' ? moment(res.data.month_str, this.dateFormat) : null,
                        });
                    });
                }

            }, null, 1);
        },
        okFun() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {

                        let url = '';

                        if (this.sbid) {
                            url = '/manage/sabill/edit';

                            values.sbid = this.sbid;
                        } else {
                            url = '/manage/sabill/save';

                            values.eid = this.eid;
                        }

                        values.month = values.month ? values.month.format(this.dateFormat) : '';

                        this.http(url, values, (res) => {
                            this.toast({content: '新增成功'});
                            this.closeModal();
                            this.$emit("confirm");
                        }, null, 1);
                    }
                }
            );
        },
        cancelFun() {
            this.closeModal();
        },
    }
}
</script>